<template>
  <div class="gsl-hrm-background-container">
    <div class="gsl-hrm-card-container">
      <div class="notification-header">
        <div class="notification-header-title">
          <oxd-text tag="h6" class="gsl-hrm-main-title">
            {{ $t('general.notification') }}
          </oxd-text>
          <oxd-icon
            v-if="notifications?.meta?.newNotification"
            name="check2-all"
            class="notification-icon-green notification-header-mobile"
            :style="{cursor: 'pointer', fontSize: '15px'}"
            @click="markAllAsRead()"
          />
        </div>

        <div class="notification-header-sub">
          <div class="notification-tabs">
            <span
              :class="{active: selectedTab === 'all'}"
              @click="setTab('all')"
            >
              All
            </span>
            <span
              :class="{active: selectedTab === 'unread'}"
              @click="setTab('unread')"
            >
              Unread
              <span
                v-if="notifications?.meta?.newNotification"
                class="notification-badge"
              >
                {{ notifications.meta.newNotification }}
              </span>
            </span>
            <span
              :class="{active: selectedTab === 'read'}"
              @click="setTab('read')"
            >
              Read
            </span>
          </div>
          <div
            v-if="notifications?.meta?.newNotification"
            class="notification-button"
            @click="markAllAsRead()"
          >
            <oxd-icon name="check2-all" class="notification-icon-green" /> Mark
            all as Read
          </div>
        </div>
      </div>

      <div v-for="notification in notifications?.data" :key="notification.id">
        <li
          class="notification-item"
          :class="{'notification-item-new': !notification.isRead}"
        >
          <div class="notification-icon-container">
            <oxd-icon
              v-if="notification.type === 'budget_exceeds'"
              name="wallet-fill"
              class="notification-icon-green"
            />
            <oxd-icon
              v-else-if="notification.type === 'document_expiry'"
              name="file-earmark-text-fill"
              class="notification-icon-green"
            />
            <oxd-icon v-else name="bell-fill" class="notification-icon-green" />
          </div>
          <div class="notification-content">
            <a @click="clickNavigateNotification(notification.link)">
              {{ notification.content }}
            </a>
            <span class="notification-time">{{ notification.createdAt }}</span>
          </div>
          <oxd-icon
            v-if="!notification.isRead"
            name="envelope-check-fill"
            class="notification-item-new-right-icon"
            @click="markAsRead(notification.id)"
          />
        </li>
      </div>
      <br />
      <oxd-pagination
        v-if="showPaginator"
        v-model:current="currentPage"
        :length="pages"
      />
    </div>
  </div>
</template>

<script>
import {OxdIcon} from '@ohrm/oxd';
import {APIService} from '@ohrm/core/util/services/api.service';
import {computed, ref} from 'vue';
import {navigate} from '@ohrm/core/util/helper/navigation';
import {formatTimeAgo} from '@/core/util/helper/datefns';
import usePaginate from '@ohrm/core/util/composable/usePaginate';

export default {
  components: {
    'oxd-icon': OxdIcon,
  },
  setup() {
    const selectedTab = ref('all');

    const http = new APIService(
      window.appGlobal.baseUrl,
      '/api/v2/core/notification',
    );

    const serializedFilters = computed(() => {
      return {
        isRead:
          selectedTab.value === 'read'
            ? 1
            : selectedTab.value === 'unread'
            ? 0
            : null,
      };
    });

    const dataNormalizer = (data) => {
      return data.map((item) => ({
        id: item.id,
        type: item.type,
        content: item.content,
        link: item.link,
        isRead: item.isRead,
        createdAt: formatTimeAgo(item.createdAt?.date),
      }));
    };

    const {
      showPaginator,
      currentPage,
      total,
      pages,
      pageSize,
      response,
      isLoading,
      execQuery,
    } = usePaginate(http, {
      query: serializedFilters,
      normalizer: dataNormalizer,
    });

    const setTab = (tab) => {
      selectedTab.value = tab;
      execQuery();
    };

    return {
      notificationCount: response,
      http,
      showPaginator,
      currentPage,
      isLoading,
      total,
      pages,
      pageSize,
      notifications: response,
      execQuery,
      selectedTab,
      setTab,
    };
  },
  methods: {
    markAsRead(id) {
      this.http.update(id, null).then(() => {
        this.execQuery();
        this.$toast.success({
          title: this.$t('general.success'),
          message: 'Marked as read',
        });
      });
    },
    clickNavigateNotification(link) {
      navigate(link);
    },
    markAllAsRead() {
      this.http
        .request({
          method: 'PUT',
          data: null,
        })
        .then(() => {
          this.execQuery();
          this.$toast.success({
            title: this.$t('general.success'),
            message: 'Marked all as read',
          });
        })
        .catch((error) => {
          console.error('Error updating notifications:', error);
        });
    },
  },
};
</script>

<style src="../styles/notification.scss" lang="scss" scoped></style>
